export enum AlarmClassification {
    Unknown = 0,
    IncorrectAlarm = 1,
    AllowedActivity = 2,
    MeasureTaken = 3,
    SkippedHandling = 99,
}
